<template>
  <div>
    <el-table :data="tableData" style="width: 100%;margin-top:20px" border stripe>
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="FCNAME" label="大类名称"></el-table-column>
      <el-table-column prop="NAME" label="产品名称"></el-table-column>
      <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
      <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
      <el-table-column prop="PRODUCT_COUNT" label="产品数量"></el-table-column>
      <el-table-column prop="SUBMIT_PRICE" label="报价"></el-table-column>
      <el-table-column label="备注" prop="DESC">
<!--        <template slot-scope="scope">-->
<!--          <el-input style="width: 60%" v-model='scope.row.DESC' :readonly="isDisabled" :disabled="isDisabled" clearable></el-input>-->
<!--        </template>-->
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination_box" v-show="totalCount > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      COMPARE_ID: 0,
      RECORD_ID: 0,
      SUPPLIER_ID: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getSupplierPrice();
    this.COMPARE_ID = Number(sessionStorage.getItem('COMPARE_ID'));
    this.RECORD_ID = Number(sessionStorage.getItem('RECORD_ID'));
    this.SUPPLIER_ID = Number(sessionStorage.getItem('SUPPLIER_ID'));
  },
  methods: {
    // 获取供应商比价列表
    getSupplierPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 24,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        RECORD_ID: Number(this.$route.params.id),
        F_CAT_ID: Number(this.$route.params.fCatId),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'success' });
        } else {
          this.tableData = res[0].PRODUCT_DATA;
          this.totalCount = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getSupplierPrice();
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/suPriceDetail.vue